import React, { Component } from "react";
import { connect } from "react-redux";
import "../../src/styles/login.scss";
import axios from "axios";
import LoginNavbar from "./loginNavbar";
import { login } from "../utils/auth";
import { apiHost } from "../api/apiClient";
import { Helmet } from "react-helmet";
import { setErrorMessage } from "../reducers/actions";

class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      rememberpwd: false,
      errorUser: false,
      errorpass: false,
      error: false,
      error_authorisation: false,
    };
  }

  componentDidMount() {
    // alert(window.location.pathname)
  }

  handleUserChange = (evt) => {
    this.setState({
      username: evt.target.value,
    });
  };

  handlePassChange = (evt) => {
    this.setState({
      password: evt.target.value,
    });
  };

  handlerememberPwd = (e) => {
    this.setState({
      rememberpwd: e.target.value
    })
  }

  handleSubmit = async (evt) => {
    var jwtDecode = require("jwt-decode");
    evt.preventDefault();
    const validate = this.handleValidation();
    if (validate) {
      try {
        const response = await axios.post(`${apiHost}/api/auth/login`, {
          Email: this.state.username,
          Password: this.state.password,
        });
        console.log("response from login", response);
        if (response.status == "200") {
          login(response.data.token, response.data.user.userName);
          this.props.setErrorMessageAction("");
          localStorage.removeItem("customer");
          this.props.history.push("/home");
          console.log("👉 Returned data:", response.data.token);
          var token = response.data.token;

          var decoded = jwtDecode(token);
          localStorage.setItem("role", decoded.role);
          localStorage.setItem("userId", decoded.nameid);

          console.log(decoded);
          window.location.reload();
        }
      } catch (e) {
        if (e.response && e.response.status == "401") {
          this.props.history.push("/login");
        }
        console.log(`😱 Axios request failed: ${e}`);
        this.setState({ error_authorisation: true });
      }
    }
  };
  handleValidation = () => {
    if (!this.state.username) {
      this.setState({ errorUser: true });
      setTimeout(() => {
        this.setState({ errorUser: true });
      }, 3000);
      return false;
    }

    if (!this.state.password) {
      this.setState({ errorPass: true });
      setTimeout(() => {
        this.setState({ errorPass: true });
      }, 3000);
      return false;
    }

    return true;
  };
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Login </title>
        </Helmet>
        <LoginNavbar></LoginNavbar>

        <div className="loginContainer">
          <div className="loginWrapper">
            <div className="loginHeader">
              <h1>Login.</h1>
              <p>Use a local account to log in.</p>
              <hr />
              {this.state.error_authorisation && (
                <p className="error-msg">Invalid login</p>
              )}
            </div>
            <div className="loginForm">
              <form className="form" onSubmit={this.handleSubmit}>
                <div className="loginInput">
                  <div className="loginInputLeft">
                    <label>Email</label>
                  </div>
                  <div className="loginInputRight">
                    <input
                      type="text"
                      data-test="username"
                      value={this.state.username}
                      onChange={this.handleUserChange}
                    />
                    <div className="error-msg">
                      {this.state.errorUser && (
                        <p>The email field is required.</p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="loginInput">
                  <div className="loginInputLeft">
                    <label>Password</label>
                  </div>
                  <div className="loginInputRight">
                    <input
                      type="password"
                      data-test="password"
                      value={this.state.password}
                      onChange={this.handlePassChange}
                    />
                    <div className="error-msg">
                      {this.state.errorPass && (
                        <p>The password field is required.</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="loginCheckbox">
                  <div className="loginInputLeft">
                    <input type="checkbox" value={this.state.rememberpwd} onChange={this.handlerememberPwd}></input>
                  </div>
                  <div className="loginInputRight">
                    <p>Remember me?</p>
                  </div>
                </div>
                <div className="loginBtnContainer">
                  <div className="loginBtn">
                    <input type="submit" value="Log in" data-test="submit" />
                  </div>
                </div>
              </form>
              <hr />
            </div>
            <div className="loginFooter">
                <p>&copy; {new Date().getFullYear()} - Vision Trak Rentals Pty Ltd </p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
